import { X } from '@/components/icons'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from './ui/drawer'
import { Button } from './ui/button'
import { useNoteGetById, useCrewNotesList } from '../lib/hooks'
import type { NoteParent } from './NoteDrawer'

interface ViewNoteDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  parent: NoteParent
  noteId: string | null
}

export function ViewNoteDrawer({
  open,
  onOpenChange,
  parent,
  noteId,
}: ViewNoteDrawerProps) {
  const isCrewMode = 'crewId' in parent
  const { data: tripNote } = useNoteGetById(
    !isCrewMode ? (noteId ?? undefined) : undefined,
  )
  const { data: crewNotes } = useCrewNotesList()
  const crewNote =
    isCrewMode && noteId ? crewNotes?.find((n) => n.id === noteId) : undefined
  const note = isCrewMode ? crewNote : tripNote

  if (!noteId) return null

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="bg-surface-L0 max-h-[85dvh] flex flex-col">
        <DrawerHeader className="flex h-14 justify-between items-center px-4 py-0 border-b border-content-primary-inverse">
          <DrawerTitle className="text-lg font-bold leading-7 tracking-[-1px] text-content-primary-bold">
            Note
          </DrawerTitle>
          <DrawerClose asChild>
            <Button
              variant="secondary"
              size="icon"
              roundness="round"
              className="size-8"
            >
              <X className="w-[14.75px] h-[14.75px]" />
            </Button>
          </DrawerClose>
        </DrawerHeader>

        <div className="min-h-0 flex-1 overflow-y-auto px-4 pt-4 pb-6">
          {!note ? (
            <p className="text-sm text-content-primary-subtle">Loading...</p>
          ) : (
            <div className="flex flex-col gap-4">
              {note.title && (
                <p className="text-base font-semibold leading-6 text-content-primary-bold">
                  {note.title}
                </p>
              )}
              <p className="text-base font-normal leading-6 text-content-primary-bold whitespace-pre-wrap">
                {note.body}
              </p>
            </div>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  )
}
